<template>
  <div class="container">

    <div v-for="(permission, index) in permissions"
         :key="index">
      <toggles-section-item :permission="permission"
                            :user-permissions="value"
                            @toggle="onToggle" />
    </div>

  </div>
</template>

<script>
import TogglesSectionItem from "./TogglesSectionItem";
import { cloneDeep } from "lodash";

export default {
  components: {
    TogglesSectionItem,
  },

  data() {
    return {
      pendingRemoval: false,
    };
  },

  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    permissions: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    emitInput(permissionKey) {
      const newVal = cloneDeep(this.value);

      const itemIndex = newVal.findIndex((permission) => {
        return permission === permissionKey;
      });

      if (itemIndex > -1) {
        newVal.splice(itemIndex, 1);
      } else {
        newVal.push(permissionKey);
      }

      this.$emit("input", newVal);
    },
    onToggle(permissionKey) {
      this.emitInput(permissionKey);
      this.emitToggle(permissionKey);
    },
    emitToggle(permissionKey) {
      this.$emit("toggle", permissionKey);
    },
  },

  computed: {},
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  /* align-content: flex-start; */
  align-items: flex-start;
  width: fit-content;
  flex-direction: column;
}
</style>
